"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    isCloudLocale: ()=>external_locale_js_namespaceObject.isCloudLocale,
    defaultCloudLocale: ()=>external_locale_js_namespaceObject.defaultCloudLocale,
    normalLocaleToCloudLocale: ()=>external_locale_js_namespaceObject.normalLocaleToCloudLocale,
    cloudLocaleToNormalLocale: ()=>external_locale_js_namespaceObject.cloudLocaleToNormalLocale,
    saveCloudLocale: ()=>external_locale_js_namespaceObject.saveCloudLocale
});
const external_locale_js_namespaceObject = require("./locale.js");
exports.cloudLocaleToNormalLocale = __webpack_exports__.cloudLocaleToNormalLocale;
exports.defaultCloudLocale = __webpack_exports__.defaultCloudLocale;
exports.isCloudLocale = __webpack_exports__.isCloudLocale;
exports.normalLocaleToCloudLocale = __webpack_exports__.normalLocaleToCloudLocale;
exports.saveCloudLocale = __webpack_exports__.saveCloudLocale;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "cloudLocaleToNormalLocale",
    "defaultCloudLocale",
    "isCloudLocale",
    "normalLocaleToCloudLocale",
    "saveCloudLocale"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
